/**
 * Язык приложения — ОДНО правило на весь LMS (решение владельца, 2026-09-24).
 *
 * Польский — язык по умолчанию ВЕЗДЕ. Русский включается только явным
 * `REACT_APP_LANG=ru`; пустая переменная, её отсутствие или любое другое
 * значение дают польский.
 *
 * 🔴 Раньше каждое место решало само: `REACT_APP_LANG || 'ru'` в i18n, датах и
 * карьерном разделе, `!== 'pl' ? ru` в календаре и деньгах. Сборка без
 * переменной выходила русской целиком, а правило в десяти копиях расходилось
 * бы и дальше. (Прод собран польским: переменная приходит из настроек
 * репозитория, в `bitbucket-pipelines.yml` её не видно — проверено по боевой
 * странице 2026-09-24. Правило — страховка, чтобы забытая переменная не
 * выкатила русскую LMS.) Сравнивать язык с
 * `'ru'`/`'pl'` по месту больше нельзя — только через эти функции.
 *
 * Близнец для сборки — `config/appLanguage.js` (webpack не читает TypeScript, а
 * `src` не может импортировать из `config`); тест
 * `src/services/__tests__/appLanguage.test.ts` держит обе копии одинаковыми.
 */
export type AppLanguage = 'pl' | 'ru';

export const DEFAULT_APP_LANGUAGE: AppLanguage = 'pl';

/** Любое значение → язык приложения: `'ru'` только при явном `'ru'`. */
export const resolveAppLanguage = (raw?: string | null): AppLanguage =>
  raw === 'ru' ? 'ru' : DEFAULT_APP_LANGUAGE;

/**
 * Язык сборки из `REACT_APP_LANG`.
 *
 * Функция, а не константа: переменная читается в момент вызова, и тесты,
 * которые переключают `process.env.REACT_APP_LANG`, видят новое значение.
 */
export const appLanguage = (): AppLanguage => resolveAppLanguage(process.env.REACT_APP_LANG);
